// import React from "react";
// import { useParams } from "react-router-dom";
// import { useGetAllRewards } from "../../api/useProducts/useReward";

// const RewardDetail = () => {
//   const { rewardId } = useParams();
//   const { data, isLoading, refetch } = useGetAllRewards({
//     id: rewardId,
//     page: 1,
//     limit: 1,
//     completed: false,
//   });
//   console.log("🚀 ~ RewardDetail ~ data:", data)

//   return <div></div>;
// };

// export default RewardDetail;

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetAllRewards } from "../../api/useProducts/useReward";
import {
  FiAward,
  FiCalendar,
  FiClock,
  FiTarget,
  FiUser,
  FiCheck,
  FiActivity,
  FiStar,
} from "react-icons/fi";
import { FaRegSadTear, FaRegSmile } from "react-icons/fa";
import { RewardData } from "../../api/types/types";
import moment from "moment";
import Loader from "../../components/Loader";
import { Sidebar } from "../../components";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";

const LoadingSpinner = () => (
  <div className="flex flex-col items-center justify-center min-h-screen p-4">
    <div className="w-12 h-12 border-4 border-blue-400 rounded-full border-t-transparent animate-spin mb-4"></div>
    <p className="text-gray-600 font-medium">Loading reward details...</p>
  </div>
);

const NoDataFound = () => (
  <div className="flex flex-col items-center justify-center min-h-screen p-4">
    <FaRegSadTear className="text-gray-400 text-6xl mb-4" />
    <h3 className="text-xl font-semibold text-gray-700 mb-2">
      No Reward Found
    </h3>
    <p className="text-gray-500 text-center">
      We couldn't find the reward you're looking for.
    </p>
  </div>
);
// @ts-ignore
const ProgressBar = ({ completed, total }) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
      <div
        className="bg-green-500 h-4 rounded-full transition-all duration-500 ease-in-out"
        style={{ width: `${percentage}%` }}
      ></div>
      <div className="text-sm text-gray-600 mt-1">{percentage}% Complete</div>
    </div>
  );
};

const RewardDetail = () => {
  const { rewardId } = useParams();
  const { data, isLoading, refetch } = useGetAllRewards({
    id: rewardId,
    page: 1,
    limit: 1,
    completed: true,
  });

  const [reward, setReward] = useState<RewardData>();

  useEffect(() => {
    if (data?.data && data?.data.length > 0) {
      // @ts-ignore
      setReward(data?.data[0]);
    }
  }, [data]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  if (!reward) {
    return <NoDataFound />;
  }

  // Extract challenge data
  const { challenge, user, completed, completedAt, createdAt, _count } = reward;
  const { completedWorkouts = 0, completedExercises = 0 } = _count || {};
  const totalWorkouts = challenge?.workoutsPerDay || 0;
  const totalExercises = reward?.totalExercises || 0;

  // Parse HTML content
  const createMarkup = (htmlContent: any) => {
    return { __html: htmlContent };
  };
  const breadcrumbItems = [
    { title: "Reward", link: "reward" },
    { title: "Detail " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-[60vh]">
          <Loader />
        </div>
      ) : (
        <div className=" py-8 px-4 sm:px-6 lg:px-8">
          <div className="w-full">
            {/* Header */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-6">
              <div className="relative">
                {challenge?.image && (
                  <img
                    src={challenge.image}
                    alt={challenge.title}
                    className="w-full max-h-96 object-cover object-center"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                  <div className="p-6 text-white">
                    <div className="flex items-center mb-2">
                      <span className="bg-blue-500 text-white text-xs font-medium px-2.5 py-1 rounded">
                        {challenge?.category?.replace("_", " ")}
                      </span>
                      <span className="bg-purple-500 text-white text-xs font-medium px-2.5 py-1 rounded ml-2">
                        {challenge?.type}
                      </span>
                    </div>
                    <h1 className="text-2xl sm:text-3xl font-bold">
                      {challenge?.title}
                    </h1>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                {/* User & Points */}
                <div className="flex flex-col sm:flex-row justify-between mb-6">
                  <div className="flex items-center mb-4 sm:mb-0">
                    <div className="w-12 h-12 rounded-full overflow-hidden shadow-md border mr-4">
                      <img
                        src={user?.profile_image || "/images/profile.jpg"}
                        alt={user?.fullName}
                        className="w-full h-full object-cover "
                      />
                    </div>
                    <div>
                      <h3 className="font-medium">{user?.fullName}</h3>
                      <p className="text-sm text-gray-500">{user?.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center bg-amber-50 px-4 py-2 rounded-lg">
                    <FiStar className="text-amber-500 text-xl mr-2" />
                    <div>
                      <p className="text-sm text-gray-600">Challenge Points</p>
                      <p className="font-bold text-amber-600">
                        {challenge?.points} points
                      </p>
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="mb-6">
                  <h2 className="text-lg font-semibold mb-3">
                    Challenge Description
                  </h2>
                  <div
                    className="prose max-w-none text-gray-700"
                    dangerouslySetInnerHTML={createMarkup(
                      challenge?.description
                    )}
                  />
                </div>

                {/* Progress */}
                <div className="mb-6">
                  <h2 className="text-lg font-semibold mb-3">Your Progress</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <div className="flex items-center mb-2">
                        <FiActivity className="text-blue-500 mr-2" />
                        <h3 className="font-medium">Completed Workouts</h3>
                      </div>
                      <ProgressBar
                        completed={completedWorkouts}
                        total={totalWorkouts}
                      />
                      <p className="text-sm text-gray-600 mt-7">
                        {completedWorkouts} of {totalWorkouts} workouts
                      </p>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg">
                      <div className="flex items-center mb-2">
                        <FiTarget className="text-green-500 mr-2" />
                        <h3 className="font-medium">Completed Exercises</h3>
                      </div>
                      <ProgressBar
                        completed={completedExercises}
                        total={totalExercises}
                      />
                      <p className="text-sm text-gray-600 mt-7">
                        {completedExercises} of {totalExercises} exercises
                      </p>
                    </div>
                  </div>
                </div>

                {/* Status and Dates */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <div className="flex items-center mb-1">
                      <FiCheck className="text-gray-500 mr-2" />
                      <h3 className="font-medium">Status</h3>
                    </div>
                    <div className="flex items-center mt-2">
                      {completed ? (
                        <>
                          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full flex items-center">
                            <FaRegSmile className="mr-1" /> Completed
                          </span>
                        </>
                      ) : (
                        <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                          In Progress
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <div className="flex items-center mb-1">
                      <FiCalendar className="text-gray-500 mr-2" />
                      <h3 className="font-medium">Started On</h3>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      {moment(createdAt).format("MMMM-DD-YYYY")}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <div className="flex items-center mb-1">
                      <FiClock className="text-gray-500 mr-2" />
                      <h3 className="font-medium">Completed On</h3>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      {completedAt
                        ? moment(completedAt).format("MMMM-DD-YYYY")
                        : "Not completed yet"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Sidebar>
  );
};

export default RewardDetail;
